<template>
  <div style="background-color:#F5F6F7;min-height: 100vh;">
    <div class="type-menu">
      <div class="type-item" :class="{ active: type === item.type }" v-for="(item,index) in tabList" :key="index">
        <div @click="switchType(item.type)">
          <span>{{item.text}}</span>
        </div>
      </div>
    </div>
    <div class="list-block">
      <OrderList :data-list="tempList" @loading="loadData" @refreshList="handleFreshList" />
      <div class="orderimg" v-if="tempList.length===0">
        <img src="@/assets/img/user_center/order.png" alt="">
        <p>暂时还没有订单</p>
      </div>
    </div>
  </div>
</template>

<script>
import OrderList from '../component/OrderList.vue'
import { FindUserInsurances } from '@/api/user'
import { AppCode, SetGetAuthInfo } from '@/util/auth'
import { mapState } from 'vuex'

export default {
  name: 'UserPolicy',
  components: {
    OrderList
  },
  data() {
    return {
      tabList: [{
        type: 'all',
        text: '全部'
      }, {
        type: 'waitPay',
        text: '待支付'
      }, {
        type: 'cancelOrder',
        text: '已取消'
      }, {
        type: 'examine_pass',
        text: '已完成'
      }],
      type: '',
      policyList: [], // 所有数据(原数据)
      tempList: [], // 遍历筛选后的数据
      hasTeYaoFeeInsu: false,
      cookieUser: {}
    }
  },

  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    this.cookieUser = SetGetAuthInfo.getInfo()
    const fromSourceCode = localStorage.getItem('fromSourceCode') || ''
    const { type } = this.$route.query
    this.type = type || 'all'
    if (this.cookieUser.userId) {
      this.loadData()
      this.switchType(this.type)
    } else {
      this.$router.push({
        path: '/user-login',
        query: {
          fromSourceCode
        }
      })
    }
  },
  methods: {
    // 刷新列表
    handleFreshList() {
      this.loadData()
    },
    // 获取所有订单列表
    async loadData() {
      this.loading = true
      try {
        const res = await FindUserInsurances({
          pageSize: 300,
          pageNum: 1,
          insuranceProductCode: process.env.VUE_APP_BAOSICODE,
          appCodeId: AppCode,
          userId: this.cookieUser.userId
        })
        this.policyList = []
        if (res) {
          for (let index = 0; index < res.dataList.length; index++) {
            this.policyList.push({ 
              ...res.dataList[index], 
              insuranceName: res.dataList[index].insuranceName, 
              insuranceProductCode: res.dataList[index].insuranceProductCode
            });
          }
          console.log('this.policyList--', this.policyList);
          this.tempList = this.policyList
        }

        // console.log('this.tempList-----', res.dataList[0].userInsurePayOrderEntities);
        // this.policyList.forEach(item => {
        //   item.isFreeInsu = /^1010A01201$/.test(
        //     item.insuranceProductCode.trim()
        //   )
        //   if (/^1010A01201$/.test(item.insuranceProductCode.trim())) {
        //     this.hasTeYaoFeeInsu = true
        //   }
        // })
      } catch (e) {
        this.$notify({ color: '#F4111F', background: '#FFEC70', message: e.message })
      }
      this.loading = false
    },
    // tab 切换
    switchType(type) {
      this.type = type
      // 清空之前数据
      this.tempList = []
      // 全部
      if (type == 'all') {
        this.tempList = this.policyList
        console.log('this.tempList ---', this.tempList);
      }
      // 待支付
      if (type == 'waitPay') {
        this.tempList = this.policyList.filter(function (item) {
          return item.payStatus === 'waitPay'
        })
      }
      // 取消
      if (type == 'cancelOrder') {
        this.tempList = this.policyList.filter(function (item) {
          return item.payStatus === 'cancelOrder' || item.payStatus === 'refund' || item.payStatus == 'abrogate' || item.payStatus == 'payClose'
        })
      }
      // 已完成
      if (type == 'examine_pass') {
        this.tempList = this.policyList.filter(function (item) {
          return item.payStatus === 'payYet' || item.payStatus === 'yetPay' || item.payStatus === 'selfAccSucess' || item.payStatus === 'partRefund'
        })
      }
    },

  }
}
</script>
<style lang="scss" scoped>
.type-menu {
  display: flex;
  align-items: center;
  background-color: #fff;

  .type-item {
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    position: relative;
    height: 40px;
    > div {
      position: relative;
      text-align: center;
      font-size: 14px;
      color: #4c4c4c;
    }

    .arc-img {
      position: absolute;
      left: 0;
      bottom: 0;
      display: none;
      width: 100%;
    }
  }

  .type-item.active {
    > div {
      color: #FF4D14;
    }
    &::after {
      position: absolute;
      content: '';
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #FF4D14;
    }

    .arc-img {
      display: inline;
    }
  }
}

.list-block {
  width: calc(100% - 20px);
  margin: 10px auto 0;
  background-color: #f5f6f7;
  p {
    font-size: 16px;
  }
}

.rec-title {
  margin: 10px 0;
  text-align: center;

  span {
    display: inline-block;
    vertical-align: middle;
    font-size: 16px;
    color: #333;
  }

  .mid-txt {
    margin: 0 10px;
  }

  .line {
    width: 6px;
    height: 1px;
    background-color: #333;
  }
}

.rec-content {
  width: 335px;
  margin: 0 auto;
  padding: 20px 0;
  background-color: #fff;
  box-shadow: 0 4px 16px 0 #eff5ff;
  border-radius: 5px;

  p {
    text-align: center;
  }

  .p1 {
    font-size: 15px;
    color: #333;
  }

  .p2 {
    font-size: 13px;
    line-height: 9px;
    margin: 6px 0 10px;
  }

  div {
    width: 122px;
    margin: 0 auto;
    text-align: center;
    background-color: #f5a623;
    color: #fff;
    font-size: 13px;
    line-height: 25px;
    border-radius: 12px;
    box-shadow: 0 2px 4px 0 #f5a623;
  }
}
.orderimg {
  margin: 150px auto;
  text-align: center;
  img {
    width: 100px;
  }
}
</style>
